import { render } from "./foot.vue?vue&type=template&id=2a57a9ba"
const script = {}

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__